import { ChangeEvent } from 'react';

import { CURRENCIES } from '@savgroup-front-common/constants';

import {
  formatStringToIntlPrice,
  formatStringToNegativeIntlPrice,
} from './intl';

export const formatPriceOnBlurHookForm = ({
  field,
  currency = CURRENCIES.EUR,
}: {
  currency?: CURRENCIES;
  field: { onChange: (price: string) => void };
}) => {
  return (event: ChangeEvent<HTMLInputElement>): void => {
    field.onChange(
      formatStringToIntlPrice({
        amount: event.target.value,
        currency,
      }),
    );
  };
};
export const formatNegativePriceOnBlurHookForm = ({
  field,
  currency = CURRENCIES.EUR,
}: {
  currency?: CURRENCIES;
  field: { onChange: (price: string) => void };
}) => {
  return (event: ChangeEvent<HTMLInputElement>): void => {
    field.onChange(
      formatStringToNegativeIntlPrice({
        amount: event.target.value,
        currency,
      }),
    );
  };
};
